import React from "react";
import PropTypes from "prop-types";
import "./pill.scss";
import { PILL_DATA, PILL_TYPE } from "./pill.constant";
import { Link } from "gatsby";
import { triggerBuzzClickEvent } from "../../../utils/garfieldHelpers";
import { EVENT_NAMES } from "../../../constants/garfieldEvents";

const Pill = ({
  data,
  pillType,
  sectionId,
  source,
  flow,
}) => {
  const handlePillClick = eventName => {
    triggerBuzzClickEvent(
      eventName,
      {
        [PILL_DATA.NAME]: data.name,
        [PILL_DATA.URL]: data.uri,
      },
      sectionId,
      source,
      flow
    );
  };
  switch (pillType) {
    case PILL_TYPE.CATEGORY:
      return (
        <Link
          className="pill category rajdhani-font"
          to={data.uri}
          onClick={() =>
            handlePillClick(
              EVENT_NAMES.CATEGORY_PILL_CLICKED
            )
          }
        >
          {data.name}
        </Link>
      );
    case PILL_TYPE.TAG:
      return (
        <Link
          className="pill tag"
          to={data.uri}
          onClick={() =>
            handlePillClick(EVENT_NAMES.TAG_PILL_CLICKED)
          }
        >
          {data.name}
        </Link>
      );
    default:
      return <></>;
  }
};

Pill.propTypes = {
  data: PropTypes.object,
  pillType: PropTypes.string,
  sectionId: PropTypes.string,
  source: PropTypes.string,
  flow: PropTypes.string,
};

export default Pill;
